export enum ClosureCodesActions {
  NEW = "NEW",
  EDIT = "EDIT",
  LOG = "LOG",
  DELETE = "DELETE"
}
export const CLOSURE_CODES_DRAWER_DEFAULT = {
  codeId: -1,
  visible: false,
  title: "",
  type: ClosureCodesActions.NEW,
};